import { actionCreatorFactory } from 'typescript-fsa';

const actionCreator = actionCreatorFactory();

export interface IAddCartDialogParam {
    show: boolean;
}

export const addCartDialogAction = actionCreator<IAddCartDialogParam>(
    'addCartDialogAction',
);
